import { Anchor, Breadcrumbs, Card, Grid, Tabs, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import MetricsSelector from '../../components/MetricsSelector';
import Metadata from '../../components/Metadata';
import ChannelBreakdownTable from '../../components/Stats/ChannelBreakdownTable';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import StepBreakdown from '../../components/Stats/StepBreakdown';
import { Page } from '../../constants/pageTitles';
import { daysAgoISODate, todayISODate } from '../../helpers/dateUtils';
import useFetch from '../../helpers/useFetch';

const page = `${Page['workflows']}`;
const initialPeriodDays = 7;

const WorkflowStatisticsPage = () => {
  const fetch = useFetch();
  const [campaign, setCampaign] = useState();
  const [error, setError] = useState();
  const [startDate, setStartDate] = useState(daysAgoISODate(initialPeriodDays - 1));
  const [endDate, setEndDate] = useState(todayISODate());
  const [tab, setTab] = useState('overview');
  const { accountId, domainId, campaignId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/campaigns/${campaignId}`)
      .then(({ campaign }) => setCampaign(campaign))
      .catch(setError);
  }, [accountId, domainId, campaignId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${campaign?.name || 'Unnamed workflow'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/workflows?mode=${campaign?.mode || 'oneOff'}`}>
          {page}
        </Anchor>
        <Text>{campaign?.name || 'Unnamed workflow'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <>
              <Card padding="md" mb="md">
                <MetricsSelector
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              </Card>
              <Tabs value={tab} onChange={setTab}>
                <Tabs.List mb="md">
                  <Tabs.Tab value="overview">Overview</Tabs.Tab>
                  <Tabs.Tab value="byChannel">By channel</Tabs.Tab>
                  <Tabs.Tab value="byStep">By step</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="overview">
                  <DetailedStatistics
                    scope="campaigns"
                    id={campaignId}
                    startDate={startDate}
                    endDate={endDate}
                    hideMetricsSelector
                  />
                </Tabs.Panel>
                <Tabs.Panel value="byChannel">
                  {campaign && (
                    <ChannelBreakdownTable
                      campaign={campaign}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  )}
                </Tabs.Panel>
                <Tabs.Panel value="byStep">
                  {campaign && (
                    <StepBreakdown
                      campaign={campaign}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  )}
                </Tabs.Panel>
              </Tabs>
            </>
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default WorkflowStatisticsPage;
